import React, { useEffect, useRef, useState } from "react";
import SvgPrinter from "./SvgPrinter";

const GAP_PX = 8;
const MIN_ITEM_PX = 44;
const MAX_ITEM_PX = 68;
const GLYPH_RATIO = 0.72;

function calcSizes(containerWidth, count) {
    if (!containerWidth || count < 1) {
        return { item: MIN_ITEM_PX, glyph: Math.round(MIN_ITEM_PX * GLYPH_RATIO) };
    }

    const totalGap = GAP_PX * Math.max(0, count - 1);
    const item = Math.min(
        MAX_ITEM_PX,
        Math.max(MIN_ITEM_PX, Math.floor((containerWidth - totalGap) / count))
    );

    return { item, glyph: Math.round(item * GLYPH_RATIO) };
}

export default function EmojiSection({
    states,
    selectedValue,
    onSelect,
    caption,
}) {
    const sectionRef = useRef(null);
    const [sizes, setSizes] = useState(() =>
        calcSizes(typeof window !== "undefined" ? window.innerWidth - 32 : 320, states.length)
    );

    useEffect(() => {
        const el = sectionRef.current;
        if (!el) return;

        const update = () => {
            setSizes(calcSizes(el.clientWidth, states.length));
        };

        update();
        const observer = new ResizeObserver(update);
        observer.observe(el);

        return () => observer.disconnect();
    }, [states.length]);

    const sectionStyle = {
        "--emoji-item-size": `${sizes.item}px`,
        "--emoji-glyph-size": `${sizes.glyph}px`,
        "--emoji-gap": `${GAP_PX}px`,
    };

    return (
        <div className="emoji-picker">
            <div
                className="emoji-section"
                ref={sectionRef}
                style={sectionStyle}
            >
                {states
                    .sort((a, b) => a.value - b.value)
                    .map((state, index) => (
                        <div
                            key={index}
                            role="button"
                            tabIndex={0}
                            aria-label={state.name}
                            aria-pressed={selectedValue === state.value}
                            className={`emoji-item${
                                selectedValue === state.value ? " selected" : ""
                            }`}
                            onClick={() => onSelect(state.value)}
                            onKeyDown={(event) => {
                                if (
                                    event.key === "Enter" ||
                                    event.key === " "
                                ) {
                                    event.preventDefault();
                                    onSelect(state.value);
                                }
                            }}
                        >
                            <SvgPrinter
                                svg={state.emoji}
                                label={state.name}
                            />
                        </div>
                    ))}
            </div>
            {caption ? (
                <div className="emoji-range-caption">{caption}</div>
            ) : null}
        </div>
    );
}
